import { useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import {
  useGetExpsenNotifyList,
  useSendNotification,
} from "./hook/expNotifyRepo";
import { useGetOrgUnitsData } from "../../Employee/hooks/useEmployee";
import { COLORS } from "../../../constants/colors";
import { showToast } from "../../../utils/toastUtils";
import axiosInstance from "../../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import { useExcelPolling } from "../../../hooks/useExcelPolling";

const expenseColumns = (handleEditView: (row: any) => void) => [
  {
    name: "Unit Name",
    selector: (row: { unitName: string }) => row.unitName,
    minWidth: "130px",
    sortable: true,
  },

  {
    name: "Month",
    selector: (row: { month: string }) => row.month,
    sortable: true,
    minWidth: "150px",
  },
  {
    name: "Pending Expense For Submit",
    selector: (row: { pndExpforSub: string }) => row.pndExpforSub,
    minWidth: "250px",
    sortable: true,
  },
  {
    name: "Pending Expense For Approved",
    selector: (row: { pndExpforApp: string }) => row.pndExpforApp,
    minWidth: "280px",
    sortable: true,
  },

  {
    name: "Pending Punch Out",
    selector: (row: { pndPunOut: string }) => row.pndPunOut,
    minWidth: "200px",
    sortable: true,
  },
  {
    name: "Action",
    width: "150px",
    cell: (row: any) => (
      <button
        onClick={() => handleEditView(row)}
        className="btn btn-primary"
        style={{
          borderRadius: "20px",
          padding: "5px",
          width: "120px",
          height: "25px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "11px",
        }}
      >
        Send Notification
      </button>
    ),
  },
];

const ExpNotify = () => {
  const { startPolling, stopPolling } = useExcelPolling();
  const [selectedOrganization, setSelectedOrganization] = useState("All");
  const [orgUnit, setOrgUnit] = useState<number | null>(null);
  const [month, setMonth] = useState<string>("");
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

  const [filterData, setFilterData] = useState({
    orgUnit: selectedOrganization,
    start: 1,
    length: 10,
    search: "",
    sortColumn: null,
    sortOrder: null,
  });

  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  const { data: SendNotication } = useSendNotification({
    enable: !!orgUnit,
    params: {
      orgUnit: orgUnit,
      month: month,
    },
  });

  const { data, isLoading, isSuccess } = useGetExpsenNotifyList({
    enable: true,
    params: {
      ...(Number.isNaN(Number(selectedOrganization))
        ? {}
        : { orgUnit: Number(selectedOrganization) }),
      start: filterData.start,
      length: filterData.length,
      ...(filterData.search === "" ? {} : { search: filterData.search }),
      sortColumn: filterData.sortColumn,
      sortOrder: filterData.sortOrder,
    },
  });

  function formatMonthRange(inputString: string) {
    // Split the input string into month and year
    const [month, year] = inputString.split("-");
    // Validate input
    if (!month || !year || month.length !== 2 || year.length !== 4) {
      throw new Error('Invalid input format. Expected "MM-YYYY"');
    }
    // Convert month to number and validate
    const monthNum = parseInt(month, 10);
    if (monthNum < 1 || monthNum > 12) {
      throw new Error("Invalid month. Month must be between 01 and 12");
    }
    // Get the first day of the month
    const firstDay = `${year}-${month}-01`;

    // Get the last day of the month
    const lastDay = new Date(parseInt(year), monthNum, 0); // Day 0 gives last day of previous month
    const lastDayFormatted = `${year}-${month}-${lastDay
      .getDate()
      .toString()
      .padStart(2, "0")}`;
    return `${firstDay}|${lastDayFormatted}`;
  }

  const handleEditView = (row: any) => {
    // Notification
    const finalResilt = formatMonthRange(row.month);
    // console.log('finalResilt',finalResilt);
    try {
      setOrgUnit(row.OrgunitId);
      setMonth(finalResilt);
    } catch (er) {
      alert(`ERror in-->${er}`);
    }
  };

  const handleChangeRowPerPage = (limit: any, page: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: page,
      length: limit,
    }));
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

  const handleSerach = (text: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      search: text,
    }));
  };

  const downloadExcelGet = async () => {
    const params: Record<string, any> = {
      ...(selectedOrganization == "All" ? {} : { orgUnit:selectedOrganization}),
      ...(filterData.search == "" ? {} : { search: filterData.search }),
    };
    const queryString = new URLSearchParams(params).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.EXPENSE_NOTIFY.GET_EXCEL_DOWNLOAD}?${queryString}`
      );
      const { fileDownloadId, intervalTime } = response?.data.data || null;
      if (fileDownloadId && intervalTime) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) =>
            setExcelStatus(currentStatus),
           onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "Report.xlsx";
            a.click();
            showToast.success("This file is ready !");
          },
          onFailed: (msg: any) => showToast.error(msg || ""),
          onExpired: (msg: any) => showToast.error(msg || ""),
          onDeleted: (msg: any) => showToast.error(msg || ""),
        });
      }
    } catch (error: any) {
      showToast.error(error);
      console.log("Error is Download ExcelFile", error);
    }
  };

  return (
    <div className="p-2">
      <div>
        <PageHeader
          title="Expense Notify"
          buttons={[
            {
              label: loadingExcel ? excelStatus? excelStatus?.charAt(0).toUpperCase() + excelStatus?.slice(1) +'..' : "" : "Excel",
              onClick: () => downloadExcelGet(),
              color: loadingExcel ?COLORS.disable :COLORS.primary,
              disable:loadingExcel ? true :false
            },
          ]}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "auto",
            marginTop: "2%",
          }}
        >
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <BasicDataTable
              SearchPlaceholder="Search By UnitName"
              dynamicHeightOnRowsPerPage={true}
              search={true}
              Title="Send Expense Notification"
              columns={expenseColumns(handleEditView)}
              data={(!isLoading && isSuccess && data.formatedData) || []}
              showSpinner={isLoading}
              paginationTotalRows={data?.rowData?.data?.recordsTotal}
              onChangeRowsPerPage={(limit: any, pageNo: any) => {
                handleChangeRowPerPage(limit, pageNo);
              }}
              onChangePage={(pageNo: number) => {
                handlePagination(pageNo);
              }}
              handleSearch={(text: any) => handleSerach(text)}
              headerContent={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  {/* Status Dropdown */}
                  <RoundedDropdown
                    options={orgUnitsList?.data || []}
                    onSelect={(value: any) => setSelectedOrganization(value.id)}
                    defaultLabel="All"
                    width="120px"
                    isShowHeading
                    DropdownHeading="Organization"
                    headingColor="#2e8dd3"
                  />
                </div>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ExpNotify;
